import Firebase from '../components/FirebaseContext';
import { User } from '../utils/types/Users';
import store from '../redux';
import { updateUser } from '../redux/actions/UserActions';
import { Platform } from 'react-native';
import Toast from 'react-native-root-toast';
import { clearPersistedState } from 'redux-easy-persist';
import * as SplashScreen from 'expo-splash-screen';
import { updateOTACounter } from '../redux/actions/OTAAction';

const auth = Firebase.auth();
const firestore = Firebase.firestore();

SplashScreen.preventAutoHideAsync();

const otaCounter = 1;

export default function Bootstrap(): void {
	auth.onAuthStateChanged(async (user) => {
		if (user == null) clearPersistedState(store);
		if (user) {
			// get user data from firebase
			const userInfo = (await firestore.collection('users').doc(user.uid).get()).data() as User;
			if (Platform.OS == 'web') {
				// [WEB ADMIN GUARD] must be an admin
				if (userInfo.role != 'Admin' && userInfo.role != 'QA Manager') {
					// deauthenticate and go back
					Toast.show('You are not an admin!', {
						duration: 10000,
						position: 72,
						shadow: true,
						backgroundColor: '#b90000',
					});
					await auth.signOut();
					return;
				}
			}
			if (store.getState().ota.counter < otaCounter) {
				Toast.show('OTA Update Received', {
					duration: 10000,
					position: 72,
					shadow: true,
					backgroundColor: '#275036',
				});
				store.dispatch(updateOTACounter({ counter: otaCounter, receivedOn: new Date() }));
			}
			store.dispatch(updateUser(userInfo));
		}
		SplashScreen.hideAsync();
	});
}
